import { useSelector } from 'react-redux';
import { Box, Typography, CircularProgress } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

import { getHrState } from '../../../../../store/selector/hr.selector';
import TopReasonsChart from './top-reasons-chart';

const TopReasons = () => {
  /* eslint-disable camelcase */
  const {
    is_loading_dashboard_list,
    dashboard_list: {
      ApplicationsReport: {
        counts: { Top3Reasons },
      },
    },
  } = useSelector(getHrState);

  const sortedKeys = Object.keys(Top3Reasons).sort();

  const sortedReasons: { [key: string]: number } = {};
  for (const key of sortedKeys) {
    sortedReasons[key] = Top3Reasons[key];
  }

  return (
    <Box sx={{ display: 'flex', height: '70vh', alignItems: 'center' }}>
      {is_loading_dashboard_list && Object.keys(Top3Reasons).length === 0 ? (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress color='primary' size={40} thickness={5} />

          <Typography sx={{ mt: '1rem' }}>Loading Top 3 Reasons</Typography>
        </Box>
      ) : (
        <>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ fontSize: '1rem' }}>Top 3 Reasons</Typography>

            <Typography sx={{ fontSize: '1.75rem' }}>HR Clearance</Typography>

            {Object.entries(sortedReasons).map(([key, value], idx) => {
              const colors = ['#02004D', '#359D78', '#F9AE2C'];
              return (
                <Box key={idx}>
                  <Box sx={{ display: 'flex', mt: '0.5rem', alignItems: 'center' }}>
                    <CircleIcon sx={{ color: colors[idx % colors.length] }} />

                    <Typography sx={{ fontSize: '0.75rem', ml: '0.625rem' }}>
                      {`${key} (${value})`}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
          <TopReasonsChart />
        </>
      )}
    </Box>
  );
};
export default TopReasons;
